import { EditorProps } from '@src/components/sco/RichMarkdownInput/utilities/EditorProps'
import { Editor } from 'slate'

export const isMarkActive = (editor: EditorProps, format: string) => {
  const marks = Editor.marks(editor)
  return marks ? marks[format] === true : false
}

export const toggleMark = (editor: EditorProps, format: string) => {
  const isActive = isMarkActive(editor, format)
  if (isActive) {
    Editor.removeMark(editor, format)
  } else {
    Editor.addMark(editor, format, true)
  }
}
